export const textFieldClearButtonName = 'text-field-clear';
export const textFieldQa = 'text-field';
